export const isSSR = process.env.VUE_APP_SSR;